import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María González',
  role: 'Docente de SIC y Economía',
  city: 'Córdoba',
  text: 'Con SIC 360 logré que los chicos por fin conecten los conceptos. Las clases ya están armadas, lo que me ahorra horas de planificación los fines de semana.'
}, {
  name: 'Roberto Fernández',
  role: 'Profesor de Contabilidad',
  city: 'Rosario',
  text: 'Antes picoteaba de libros viejos y PDFs de internet. Ahora tengo un camino claro. Mis alumnos de 4to año cambiaron totalmente la actitud.'
}, {
  name: 'Laura Martínez',
  role: 'Docente Nivel Secundario',
  city: 'La Plata',
  text: 'Empecé a dar clases hace poco y me sentía muy insegura improvisando. Este material fue mi salvación. Es como tener un mentor que te dice exactamente cómo explicar cada tema.'
}, {
  name: 'Esteban Ruiz',
  role: 'Profesor de Gestión',
  city: 'Mendoza',
  text: "Es increíble cómo cambia la dinámica cuando explicás el 'por qué' antes del 'cómo'. Una herramienta indispensable para el aula de hoy."
}, {
  name: 'Patricia Cabrera',
  role: 'Docente y Contadora',
  city: 'Mar del Plata',
  text: 'El banco de ejemplos y las evaluaciones listas son oro puro. Dejé de llevarme trabajo a casa.'
}];
export function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent(p => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setCurrent(p => (p + 1) % TESTIMONIALS.length);
  const t = TESTIMONIALS[current];
  return <section className="py-12 bg-slate-50" data-id="element-329">
      <div className="max-w-2xl mx-auto px-4" data-id="element-330">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 text-center mb-8" data-id="element-331">
          Lo que dicen otros <span className="text-blue-600" data-id="element-332">docentes</span>
        </h2>

        <div className="relative bg-white rounded-2xl shadow-md border border-slate-100 p-8" data-id="element-333">
          {/* Stars */}
          <div className="flex gap-1 mb-4" data-id="element-334">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-335" />)}
          </div>

          {/* Quote */}
          <p className="text-slate-700 text-lg italic leading-relaxed mb-6" data-id="element-336">
            "{t.text}"
          </p>

          {/* Author */}
          <div className="flex items-center gap-3" data-id="element-337">
            <div className="bg-blue-100 rounded-full w-10 h-10 flex items-center justify-center font-bold text-blue-600 text-lg flex-shrink-0" data-id="element-338">
              {t.name[0]}
            </div>
            <div data-id="element-339">
              <p className="font-bold text-slate-900 text-sm" data-id="element-340">{t.name}</p>
              <p className="text-xs text-slate-500" data-id="element-341">
                {t.role} · {t.city}
              </p>
            </div>
          </div>

          {/* Nav arrows */}
          <div className="absolute top-1/2 -translate-y-1/2 -left-4" data-id="element-342">
            <button onClick={prev} className="bg-white border border-slate-200 shadow p-2 rounded-full hover:bg-slate-50 transition-colors" data-id="element-343">
              <ChevronLeft className="w-4 h-4 text-slate-600" data-id="element-344" />
            </button>
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 -right-4" data-id="element-345">
            <button onClick={next} className="bg-white border border-slate-200 shadow p-2 rounded-full hover:bg-slate-50 transition-colors" data-id="element-346">
              <ChevronRight className="w-4 h-4 text-slate-600" data-id="element-347" />
            </button>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-5" data-id="element-348">
          {TESTIMONIALS.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`h-2 rounded-full transition-all ${i === current ? 'bg-blue-600 w-6' : 'bg-slate-300 w-2'}`} data-id="element-349" />)}
        </div>
      </div>
    </section>;
}